export async function getSupabaseFunctionErrorMessage(error: unknown, fallback: string) {
  const message = error instanceof Error ? error.message : "";
  const context = (error as { context?: Response } | null)?.context;

  if (context instanceof Response) {
    try {
      const body = await context.clone().json();
      if (typeof body?.error === "string" && body.error.trim()) return body.error;
      if (typeof body?.message === "string" && body.message.trim()) return body.message;
    } catch {
      try {
        const text = await context.clone().text();
        if (text.trim()) return text;
      } catch {
        // ignore and fall back below
      }
    }
  }

  if (message && message !== "Edge Function returned a non-2xx status code") {
    return message;
  }

  return fallback;
}